import { Heading, Button, Stack, Center, Container, Flex } from '@chakra-ui/react';
import { CancelModal } from '../Modals';
import { useState } from 'react';
import { Select } from '../Input';

export function QuestionnaireHeaderNew({
 heading,
 submitFunction,
 isSubmitEnabled = false,
 isSubmitting,
 isSubmit,
 isFullWidth = false,
 hasReplicableSelect = false,
 onReplicableChange,
 submitLabel = 'Finalizar',
 children,
}) {
 const [cancelModalIsOpen, setCancelModalIsOpen] = useState(false);
 const [replicabilityValue, setReplicabilityValue] = useState(hasReplicableSelect);

 const handleReplicabilityChange = (value) => {
  setReplicabilityValue(value);
  onReplicableChange(value);
 };

 return (
  <Center bg='white' borderBottom={['1px solid #E5E5E5', 'unset']} px={{ xl: '86px' }}>
   <Container maxW={isFullWidth ? '1700px' : '1280px'} p={0}>
    <Flex align='center' justify='space-between' py='32px'>
     <Stack display='inline' align='flex-start' w='50%'>
      <Heading fontSize='24px' mb='16px'>
       {heading}
      </Heading>
      <Flex gap='3' align='center' w='100%'>
       {children}
      </Flex>
     </Stack>

     <Flex gap='16px' w='50%' justify='end'>
      {hasReplicableSelect !== false && (
       <Flex w='400px'>
        <Select
         placeholder='Selecione a replicabilidade'
         options={[
          { label: 'Não replicável', value: 'non-replicable' },
          {
           label: 'Replicável por admin',
           value: 'ADMIN',
          },
          { label: 'Replicável por todos', value: 'ADMIN/RESPONDENT' },
         ]}
         defaultValue={replicabilityValue}
         onChange={(e) => handleReplicabilityChange(e.target.value)}
         h='59px'
         bg='white'
         border='1px solid #CCCFD1'
         fontWeight='400'
        />
       </Flex>
      )}

      <Button
       variant='cancel'
       w='133px'
       minW='133px'
       h='59px'
       onClick={() => setCancelModalIsOpen(true)}
      >
       Cancelar
      </Button>

      <Button
       type={isSubmit ? 'submit' : 'button'}
       variant='primary'
       w='129px'
       minW='129px'
       h='59px'
       isLoading={isSubmitting}
       isDisabled={!isSubmitEnabled}
       {...(!isSubmit && { onClick: submitFunction })}
      >
       {submitLabel}
      </Button>
     </Flex>
    </Flex>
   </Container>
   <CancelModal
    isOpen={cancelModalIsOpen}
    onClose={() => setCancelModalIsOpen(false)}
    title='Deseja mesmo cancelar?'
    content='Ao continuar, todas as informações serão perdidas.'
    isLoading={false}
   />
  </Center>
 );
}
